<template>
  <div>
    <!-- LIST START -->
    <template>
      <v-card class="mx-auto" tile>
   
      </v-card>
    </template>
  </div>
</template>



<!-- LIST SLUTT -->


<script>
import axios from "axios";

export default {
  name: "CommentTemplate",
  //   props: ["myProp"], //Single prop
  props: {
    id: Number,
    text: String, //from view
    boxOpenOrClose: Boolean,
    commentText: String
  },
  data() {
    return {
      //data
      items: [],
      currentitems:[],
      errors: [],
      compId: this.id,
      compText: this.text,
      eventId: this.id,
      openOrClose: this.boxOpenOrClose
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.getCookies();
    this.setEvent(this.openOrClose);
 
  },

  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);

    },
    setEvent(openOrClose) {
    //   var regId = this.selectedEventOpener.RegId;
      var regId = this.cookieRegId;
      var eventId = this.eventId;
      var isOpen = openOrClose;
      var ac = this.ac;
      var comment = this.commentText;
      if (comment === null) {
        comment = "";
      }
      var toSubmit = JSON.stringify({ eventId, regId, isOpen, ac, comment });
      var apimethod = "setevent";
      const uri = this.baseUrl + apimethod;
    //   console.log(uri);
    //   console.log(toSubmit);
    //   this.$emit("exec_response", toSubmit);
      this.post(uri, toSubmit, apimethod);
    },
    post(uri, toSubmit,apimethod) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.currentitems = response.data;
          this.loading = false;
        //   console.log(this.currentitems);
          this.setDataArray(apimethod);
         }
        )
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setDataArray(apimethod)
    {
        if (apimethod == "setevent")
        {
            this.items = this.currentitems;
            console.log("execResponse",this.items);
            this.$emit("exec_response", this.items[0]);
        }

    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
  },
};
</script>
